import { type RootState } from "../../../../Application/globaltypes/redux";
import { createSelector } from "@reduxjs/toolkit";
import { type TagsPayloadCamelPlural } from "../../../../../interfaces/Tags";
import { mapTagsToView } from "../../../Common/helpers/tagsHelper";

export const surveysTagsSelector = createSelector(
  [(state: RootState): TagsPayloadCamelPlural => state.library.surveys.base.common.tags],
  mapTagsToView,
);
